import { useParams } from "react-router-dom";
import useRemoteSources from "./useRemoteSources";

export default function useRemoteSource() {
  const { source: sourceSlugOrId } = useParams();
  const { sources } = useRemoteSources();
  if (!sources) return null;

  const filteredSources = Object.keys(sources)
    .map((id) => sources[id])
    .filter((source) => [source.id, source.slug].includes(sourceSlugOrId));

  if (filteredSources.length === 1) return filteredSources[0];

  throw new Error(
    `useRemoteSource() - found ${filteredSources.length} sources with id or slug: ${sourceSlugOrId}`
  );
}
